import script from "./List.vue?vue&type=script&setup=true&lang=ts"
export * from "./List.vue?vue&type=script&setup=true&lang=ts"

import "./List.vue?vue&type=style&index=0&id=099951a3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099951a3"]])

export default __exports__